module.exports = __webpack_public_path__ + "static/2-c49471f00adb5270c2a626cd9019a034.png";